import { useRef } from 'react';
import useModalA11y from '../hooks/useModalA11y';

function GenericConfirmationModal({
    isOpen,
    onCancel,
    onConfirm,
    title,
    message,
    textCancel,
    textConfirm,
    children,
}) {
    const dialogRef = useRef(null);

    useModalA11y({ isOpen, dialogRef, onClose: onCancel });

    if (!isOpen) {
        return null;
    }

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            //onClick={onClose} // Close on backdrop click
        >
            <div
                ref={dialogRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby="genericConfirmationTitle"
                tabIndex={-1}
                className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md"
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
            >
                <h2 id="genericConfirmationTitle" className="text-2xl font-semibold mb-4 text-primary-dark">{title}</h2>
                <div className="mb-5 p-3">
                    <p className="mb-2 text-neutral-dark">{message}</p>
                    {children}
                </div>

                <div className="flex justify-end space-x-3">
                    <button
                        type="button"
                        onClick={onCancel}
                        className="px-4 py-2 w-1/2 md:w-1/3 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 disabled:opacity-50"
                    >
                        {textCancel}
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        className="px-4 py-2 w-1/2 md:w-1/3 bg-button text-white rounded-md hover:bg-button-light focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50 disabled:opacity-50 flex items-center justify-center min-w-[100px]"
                    >
                        {textConfirm}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default GenericConfirmationModal;
